import { useSelector } from 'react-redux';

import {
  selectIsAnonymousRetailerAccess,
  selectIsAuthenticatedRetailerAccess,
  selectRetailerCommunicationSetText,
  selectRetailerCommunicationStyleOrder,
  selectRetailerData,
  selectRetailerDefaultLanguage,
  selectRetailerError,
  selectRetailerId,
  selectRetailerLanguages,
  selectRetailerLoading,
  selectRetailerLogo,
  selectRetailerMaxLengthTastePathPerCategory,
  selectRetailerName,
  selectRetailerPageType,
  selectRetailerPrivacyUrl,
  selectRetailerSlug,
  selectRetailerTags,
  selectRetailerWidgetAccess,
} from '@lib/core/retailers/selectors/retailer';

export const useRetailer = () => {
  return {
    isAnonymousRetailerAccess: useSelector(selectIsAnonymousRetailerAccess),
    isAuthenticatedRetailerAccess: useSelector(selectIsAuthenticatedRetailerAccess),
    isRetailerLoading: useSelector(selectRetailerLoading),
    retailerAuthType: useSelector(selectRetailerWidgetAccess),
    retailerCommunicationSetText: useSelector(selectRetailerCommunicationSetText),
    retailerCommunicationStyleOrder: useSelector(selectRetailerCommunicationStyleOrder),
    retailerData: useSelector(selectRetailerData),
    retailerDefaultLanguage: useSelector(selectRetailerDefaultLanguage),
    retailerError: useSelector(selectRetailerError),
    retailerId: useSelector(selectRetailerId),
    retailerLanguages: useSelector(selectRetailerLanguages),
    retailerLogo: useSelector(selectRetailerLogo),
    retailerMaxLengthTastePathPerCategory: useSelector(selectRetailerMaxLengthTastePathPerCategory),
    retailerName: useSelector(selectRetailerName),
    retailerPageType: useSelector(selectRetailerPageType),
    retailerPrivacyLink: useSelector(selectRetailerPrivacyUrl),
    retailerSlug: useSelector(selectRetailerSlug),
    retailerTags: useSelector(selectRetailerTags),
  };
};
